@if(status){
<div class="status-chip" [ngClass]="status.toLowerCase()">
    @switch (status) {
    @case ('IN_PROGRESS') {en cours}
    @case ('COMPLETED') {terminé}
    @case ('WAITING_RESPONSE') {en attente de réponse}
    @case ('ERROR') {erreur}
    @default {en attente}
    }
</div>
}